var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.668 24.5H58.8585L68.2215 15.1369L62.4477 9.36304L49.0013 22.8095L35.5549 9.36304L29.7811 15.1369L39.1441 24.5H16.3346C11.8307 24.5 8.16797 28.1627 8.16797 32.6666V77.5833C8.16797 82.0872 11.8307 85.75 16.3346 85.75H81.668C86.1719 85.75 89.8346 82.0872 89.8346 77.5833V32.6666C89.8346 28.1627 86.1719 24.5 81.668 24.5ZM16.3346 77.5833V32.6666H81.668L81.6761 77.5833H16.3346Z",
    fill: "#DA0067"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.c19026d51958ebb2d4324c3132e273b4.svg";
export { ForwardRef as ReactComponent };